<template>
    <v-container app :fluid="true">
        <v-row justify="center">
            <v-col cols="12" class="pt-0">
                <v-card>
                    <v-card-text class="pt-0 pb-0">
                        <template>
                            <v-row>
                                <v-col cols="6">
                                    <v-text-field
                                        v-model="search"
                                        append-icon="fas fa-search"
                                        label="Buscar insumo"
                                        hide-details
                                        class="wost-text-input"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="6">
                                    <v-btn class="float-right" dark color="primary" 
                                        :disabled="showButtonSave"
                                        @click="handleSaveStock"
                                        v-if="verifyPermission('guardar_inventario')">
                                        Guardar
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </template>                        
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" class="pb-0">
                <v-card>
                    <template>
                        <v-row>
                            <v-col cols="12">
                                <v-data-table
                                    class="wost-table"
                                    :headers="headers"
                                    :items="supplies"
                                    item-key="id"
                                    :search="search"
                                    height="66vh"
                                    fixed-header
                                >
                                    <template v-slot:item.category_id="{ item }">
                                        {{ item.category.name }}
                                    </template>
                                    <template v-slot:item.unit_id="{ item }">
                                        {{ item.unit.name }}
                                    </template>
                                    <template v-slot:item.valued="{ item }">
                                        {{ (item.stock * item.cost) | currency('S/') }}
                                    </template>
                                    <template v-slot:item.new_stock="{ item }">
                                        <v-text-field 
                                            v-if="new_stocks[getIndex(item.id)]"
                                            type="number"
                                            v-model="new_stocks[getIndex(item.id)].new_stock"
                                            outlined
                                            dense
                                            hide-details
                                            class="input-stock float-right"
                                        ></v-text-field>
                                    </template>
                                    <template v-slot:item.action="{ item }">
                                        <v-btn small @click="handleViewKardex(item)" 
                                            dark 
                                            color="grey darken-1"
                                            v-if="verifyPermission('ver_kardex_inventario')">
                                            Kardex
                                        </v-btn>
                                    </template>
                                </v-data-table>
                            </v-col>
                        </v-row>
                    </template>
                </v-card>
            </v-col>
        </v-row>
        <Kardex ref="kardex" />
    </v-container>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import router from '@/router/index';
import Kardex from '../../components/Production/Kardex'

import {APIService} from '@/APIService';
const apiService = new APIService();

export default {
    name: 'Inventory',
    components: {
        Kardex
    },
    computed: {
        ...mapState('production', [
            'supplies',
            'kardexSupply'
        ]),
        showButtonSave(){
            let hideButton = true
            let numberItemsModified = 0
            this.new_stocks.forEach((element)=>{
                if (parseFloat(element.new_stock) > 0) {
                    numberItemsModified++
                }
            })
            if (numberItemsModified > 0) {
                hideButton = false
            }
            return hideButton
        }
    },
    data(){
        return {
            search: '',
            //showButtonSave: false,
            new_stocks: [],
            headers: [
                { text: 'Descripción', value: 'name', align: 'left', sortable: false, class: 'header-table'},
                { text: 'Categoría', value: 'category_id', align: 'left', sortable: false, class: 'header-table', width: 120 },
                { text: 'Und. de medida', value: 'unit_id', align: 'left', sortable: false, class: 'header-table', width: 140 },
                { text: 'Stock', value: 'stock', align: 'a-right', sortable: false, class: 'header-table', width: 170 },
                { text: 'Valorizado', value: 'valued', align: 'a-right', sortable: false, class: 'header-table', width: 170 },
                { text: 'Stock Nuevo', value: 'new_stock', align: 'a-right', sortable: false, class: 'header-table', width: 170 },
                { text: 'Acciones', value: 'action', sortable: false, class: 'header-table', width: 35 },
                { text: '', value: 'data-table-expand', width: 10, class: 'header-table-expand' }
            ]
        }
    },
    methods: {
        ...mapActions('production', [
            'getSupplies',
            'runSetSupplySelected',
            'getKardexBySupply',
            'runsetSupplies'
        ]),
        ...mapActions('general', [
            'setNameSection'
        ]),
        handleViewKardex(supply){            
            this.runSetSupplySelected(supply)

            //this.getKardexBySupply()
            //this.$refs.kardex.showForm('Kardex')

            this.setNameSection('Kardex de insumos');
            router.push('/supply-kardex');
        },
        handleSaveStock(){
            let new_inventory = []
            this.new_stocks.forEach((element) => {
                if (parseFloat(element.new_stock)){
                    new_inventory.push(element)
                }
            })
            let data = {
                new_stocks: new_inventory
            }
            apiService.saveNewInventory(data).then((response) => {
                this.getSupplies()
                this.fillNewStock()
                this.$notify({
                    group: 'foo',
                    type: 'success',
                    title: 'RESULTADO DE REGISTRO DE INVENTARIO',
                    text: 'El nuevo stock se registró con éxito.!'
                })
            }).catch( function(error){
                console.log('Ocurrió un error')
            });
        },
        fillNewStock(){
            this.new_stocks = []
            this.supplies.forEach((element) => {
                let item = {
                    supply_id: element.id,
                    new_stock: null
                }
                this.new_stocks.push(item)
            });
        },
        getIndex(supply_id) {
            return this.new_stocks.findIndex(i => i.supply_id === supply_id)
        },
        loadData() {
            apiService.getSuppliesProduction()
                .then(({data}) => {
                    this.runsetSupplies(data)
                    this.fillNewStock()
                })
        },
        verifyPermission(permission) {
            return this.$hasPermision(permission)
        }
    },
    mounted(){
        this.loadData()        
    }
}
</script>

<style scoped>
.header-table-production{
    background-color: #3949AB !important;
    color: #ffffff !important;
    text-transform: uppercase;
    line-height: 30px;
}

.input-stock{
    width: 80px !important;
}
</style>